import { TweenMax, Power4 } from 'gsap';

class HeroSlider {
  constructor(view = null) {
    this.heroSlider = (view ? view.querySelector('.js-hero-slider') : document.querySelector('.js-hero-slider'));
    this.slides = [...this.heroSlider.querySelectorAll('.js-slide')];
    this.prev = this.heroSlider.querySelector('.js-prev');
    this.next = this.heroSlider.querySelector('.js-next');

    this.data = {
      current: 0,
      next: 1,
      total: this.slides.length - 1,
      interval: 5000
    };
  }

  animate = (currentSlide, nextSlide) => {
    // fade out current slide
    TweenMax.fromTo(
      currentSlide,
      2,
      { autoAlpha: 1 },
      { autoAlpha: 0, ease: Power4.easeOut }
    );

    // fade in next slide
    TweenMax.fromTo(
      nextSlide,
      2,
      { autoAlpha: 0 },
      { autoAlpha: 1, ease: Power4.easeOut }
    );
  }

  autoPlay = () => {
    const currentSlide = this.slides[this.data.current];
    const nextSlide = this.slides[this.data.next];

    this.animate(currentSlide, nextSlide);

    this.data.current = this.data.current === this.data.total ? 0 : this.data.current + 1;
    this.data.next = this.data.current === this.data.total ? 0 : this.data.current + 1;
  }

  transition = (e) => {
    const dir = e.target.getAttribute('data-dir');
    const currentSlide = this.slides[this.data.current];
    let nextSlide;

    if (dir === '>') nextSlide = this.slides[this.data.next];
    if (dir === '<') nextSlide = this.slides[this.data.prev];

    this.animate(currentSlide, nextSlide);

    // update data
    if (dir === '<') {
      this.data.next = this.data.current;
      this.data.current = this.data.current === 0 ? this.data.total : this.data.current - 1;
      this.data.prev = this.data.prev === 0 ? this.data.total : this.data.prev - 1;
    }

    if (dir === '>') {
      this.data.prev = this.data.current;
      this.data.current = this.data.current === this.data.total ? 0 : this.data.current + 1;
      this.data.next = this.data.next === this.data.total ? 0 : this.data.next + 1;
    }
  }

  init() {
    if (this.prev && this.next) {
      this.prev.addEventListener('click', this.transition, { passive: true });
      this.next.addEventListener('click', this.transition, { passive: true });
    }

    if (!this.prev || !this.next) setInterval(this.autoPlay, this.data.interval);
  }

  destroy = () => {
    if (this.prev && this.next) {
      this.prev.removeEventListener('click', this.transition);
      this.next.removeEventListener('click', this.transition);
    }
  }
}

export default HeroSlider;
